import { NgModule } from '@angular/core';
import { CoreCacheService } from './services/core-cache.service';
import { IndexeddbCoreCacheService } from './services/indexeddb-core-cache.service';


@NgModule({
    providers: [
        CoreCacheService,
        IndexeddbCoreCacheService
    ]
})
export class CoreCacheModule {
}
